import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/Button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/Tabs";
import { Separator } from "../components/ui/Separator";
import { ChevronLeft } from "lucide-react";
import OverviewTab from "../components/Payments/OverviewTab";
import DiscountTiersTab from "../components/Payments/DiscountTiersTab";
import PromoCodesTab from "../components/Payments/PromoCodesTab";
import PartnersTab from "../components/Payments/PartnersTab";

const TABS = ["overview", "discount-tiers", "promo-codes", "partners"] as const;
type Tab = (typeof TABS)[number];

function Payments() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab: Tab =
    (TABS.find((t) => t === searchParams.get("tab")) as Tab) ?? "overview";

  const handleTabChange = (tab: string) => {
    setSearchParams({ tab });
  };

  return (
    <div className="min-h-screen p-6">
      <div className="mx-auto max-w-5xl">
        {/* Header */}
        <div className="mb-6 flex items-center gap-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate("/route-select")}
            className="flex items-center gap-1"
          >
            <ChevronLeft className="h-4 w-4" />
            Back to Routes
          </Button>
          <Separator orientation="vertical" className="h-6" />
          <h1 className="text-2xl font-semibold">Payments</h1>
        </div>

        {/* Tabs */}
        <Tabs value={activeTab} onValueChange={handleTabChange}>
          <TabsList className="mb-6 grid w-full grid-cols-4">
            <TabsTrigger value="overview">Overview</TabsTrigger>
            <TabsTrigger value="discount-tiers">Discount Tiers</TabsTrigger>
            <TabsTrigger value="promo-codes">Promo Codes</TabsTrigger>
            <TabsTrigger value="partners">Partners</TabsTrigger>
          </TabsList>

          <TabsContent value="overview">
            <OverviewTab />
          </TabsContent>

          <TabsContent value="discount-tiers">
            <DiscountTiersTab />
          </TabsContent>

          <TabsContent value="promo-codes">
            <PromoCodesTab />
          </TabsContent>

          <TabsContent value="partners">
            <PartnersTab />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}

export default Payments;
